import { OnInit, ElementRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import 'rxjs/add/operator/takeWhile';

import { CommonDataService } from 'app/services/common-data.service';

export abstract class RouteComponentBase<T> implements OnInit {
    protected constructor(public readonly elementRef: ElementRef, private readonly platformId: any, public readonly commonData: CommonDataService, private readonly pageTitleKey: string) {
        this.translateService = this.commonData.translateService;
    }

    protected readonly translateService: TranslateService;

    public isInitialized: boolean;

    protected destroyed: boolean;

    ngOnInit(): void {
        const element = this.elementRef.nativeElement as HTMLElement;
        if (element) {
            element.classList.add('d-flex');
            element.classList.add('flex-1-1-auto');
        }

        if (!isPlatformBrowser(this.platformId))
            return;

        this.commonData.setPageTitle(this.pageTitleKey);

        setTimeout(() => this.loadInitialData(), 1);
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    protected abstract initialDataLoader: () => Observable<T>;

    protected abstract onInitialDataLoaded: (data: T, hideLoadingImg: () => void) => void;

    protected askSaveChanges = (onYes: () => void, onNo?: () => void, onCancel?: () => void): void => {
        this.translateService.get(['ThereAreUnsavedChanges', 'WantToSaveThemBeforeProceedQuestion'])
            .subscribe(msgs => {
                const questions = [msgs['ThereAreUnsavedChanges'], msgs['WantToSaveThemBeforeProceedQuestion']];
                this.commonData.showQuestions(questions, onYes, onNo, onCancel);
            });
    }

    private loadInitialData = (): void => {
        this.commonData.showLoadingImg = true;

        this.initialDataLoader().takeWhile(() => !this.destroyed && !this.isInitialized).subscribe(data => {
            this.commonData.isAnyInitDataLoaded = true;

            this.onInitialDataLoaded(data as T, () => this.commonData.showLoadingImg = false);
        },
            e => {
                this.commonData.isAnyInitDataLoaded = true;

                if (e === 401){
                    console.error(401, 'loadInitialData')
                } else {
                    this.commonData.showErrors([e.message || e]);
                }

                this.commonData.showLoadingImg = false;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/route-component-base.ts